/**
 * Utilidades para manejo de archivos
 */

export const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
export const ALLOWED_DOCUMENT_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']

export class FileUtils {
  static validateFile(file: File, allowedTypes: string[] = ALLOWED_DOCUMENT_TYPES): string | null {
    // Validar tamaño
    if (file.size > MAX_FILE_SIZE) {
      return 'El archivo es demasiado grande. Máximo 50MB'
    }

    // Validar tipo
    if (!allowedTypes.includes(file.type)) {
      return `Tipo de archivo no permitido. Formatos permitidos: ${allowedTypes.map(t => t.split('/')[1]).join(', ')}`
    }

    return null
  }

  static async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const result = reader.result as string
        resolve(result.split(',')[1]) // Remover el prefijo data:image/...;base64,
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  static formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }

  static getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || ''
  }
}
